module.exports = __webpack_public_path__ + "assets/img/Type E (86).9417a95e.jpg";